import _ from "lodash";
import * as Yup from "yup";
import { useState } from "react";
import { useFormik } from "formik";
import { FormInput } from "../../common/form-controllers/FormInput";
import { ToastService } from "../../../services/toast.service";
import { FormDropdown } from "../../common/form-controllers/FormDropdown";
import { PROGRAM_SUBTYPE } from "../../../consts/methods.consts";
import { useSearchParams } from "react-router-dom";
import { PageHeaderActions } from "../../common/page-header/PageHeader";
import { useTableDataProvider } from "../../hooks";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { ChakraModal, PageHeader } from "../../index";
import { useGetQuery, usePostMutation } from "../../../services/api.service";
import ChakraTable, { ChakraTableColumns } from "../../common/chakra-table/ChakraTable";
import { DROPDOWN_TAGS, PROGRAM_SUBTYPE_TAGS } from "../../../consts/tags.consts";
import { customeJsonParser } from "../../../utils/utils";


const ProgramSubtypeListPage = () => {
    const disclosure = useDisclosure()
    const [page, setPage] = useState(1)
    const toast = new ToastService(useToast())
    const [isSelected, setIsSelected] = useState<boolean>(false);
    const [create] = usePostMutation();

    const { data, isLoading, isFetching } = useGetQuery({
        method: PROGRAM_SUBTYPE.LIST,
        body: {
            page: page,
        },
        providesTags: [PROGRAM_SUBTYPE_TAGS.LIST]
    })

    const { data: initialData } = useGetQuery({
        method: PROGRAM_SUBTYPE.INIT,
        providesTags: [PROGRAM_SUBTYPE.INIT, DROPDOWN_TAGS.LIST]
    })

    const { dataList, paginationDetails } = useTableDataProvider(data);
    const programTypes = _.get(initialData, ['message'], [])

    const formik = useFormik({
        initialValues: {
            title: ''
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Name is required"),
            program_type: Yup.string().required("Program type is required"),
        }),
        onSubmit: async (values) => {
            try {
                await create({
                    method: isSelected ? PROGRAM_SUBTYPE.UPDATE : PROGRAM_SUBTYPE.ADD,
                    body: values,
                    invalidatesTags: [PROGRAM_SUBTYPE_TAGS.LIST, DROPDOWN_TAGS.LIST]
                }).unwrap();

                toast.setTitle("Success").setDescription(`${isSelected ? "Program subtype details have been saved" : "Program subtype has been created successfully"}`).showSuccessToast();

            } catch (error: any) {
                let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
                if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();

            } finally {
                disclosure.onClose();
                setIsSelected(false);
            }
        }
    })

    const ondeleteHandler = async (item: any) => {
        try {
            const res = await create({
                method: PROGRAM_SUBTYPE.DELETE,
                body: { id: item?.name },
                invalidatesTags: [PROGRAM_SUBTYPE_TAGS.LIST, DROPDOWN_TAGS.LIST]
            }).unwrap();

            toast.setTitle("Success").setDescription("Program subtype is deleted successfully.").showSuccessToast();

        } catch (error: any) {
            let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
            if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();
        }

    }

    const PROGRAM_SUBTYPE_COLUMNS: ChakraTableColumns = [
        {
            header: "Name",
            accessor:
                "title",
        },
        {
            header: "Program Type",
            accessor:
                "program_type_name",
        },
        {
            header: "Actions",
            accessor: '',
            disabled: false,
            width: 100,
            options: [
                {
                    label: "Edit",
                    confirmation: false,
                    onClick(item) {
                        formik.setFieldValue("title", _.get(item, "title"))
                        formik.setFieldValue("name", _.get(item, "name"))
                        formik.setFieldValue("program_type", _.get(item, "program_type"))
                        setIsSelected(true)
                        disclosure.onOpen()
                    },
                },
                {
                    label: "Delete",
                    onClick: ondeleteHandler,
                }
            ]
        }
    ]

    const actions: PageHeaderActions = [

        {
            text: "Create New",
            confirmation: false,
            onClick: () => {
                setIsSelected(false)
                formik.resetForm();
                disclosure.onOpen()
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]

    const onPage = (page: any) => {
        setPage(page)
    }

    return (
        <>
            <div>
                <PageHeader subtitle="View and Manage Program Subtypes" title={`Programs Subtypes`} actions={actions} />
                <ChakraTable onPage={onPage} isFetching={isFetching} paginationDetails={paginationDetails} isLoading={isLoading} pagination size={"sm"} header
                    title="Program Subtypes"
                    columns={PROGRAM_SUBTYPE_COLUMNS} data={dataList} />
                <ChakraModal primaryAction={formik.submitForm} primaryButtonText={"Save"} modalTitle={`${isSelected ? 'Edit Program Subtype' : 'New Program Subtype'}`} {...disclosure}>
                    <FormInput isRequired formik={formik} name="title" autoFocus label="Name" />
                    <FormDropdown options={programTypes}
                        label="Program Type" formik={formik}
                        name="program_type" />
                </ChakraModal>
            </div>
        </>
    )
}

export default ProgramSubtypeListPage